import CircularProgress from '@material-ui/core/CircularProgress';

import { LoaderContainer } from './styled';

/*
 * Just a wrapper of Material-UI's CircularProgress, with some style.
 */

const CustomLoader = () => {
    return (
        <LoaderContainer>
            <CircularProgress />
        </LoaderContainer>
    );
};

export default CustomLoader;
